import { useSetState } from 'ahooks'
import { Button, message, Spin } from 'antd'
import { useEffect, useRef } from 'react'
import { SDrawerOrModal, SGeneralForms, STooltipInput } from 'shj-components'
import { startCustomDrawing } from '@/services/order'
import { cloneDeep } from 'lodash-es'

interface IProps {
  title: string
  open: boolean
  orderId: string
  setOpen: (open: boolean) => void
  uploadFn:any
  vendorList: any
  drawerList: any
}
export default function SubmitWorkModal(prpos: IProps) {
  const formRef = useRef(null)
  const { open, title, setOpen, orderId, vendorList, drawerList, uploadFn } = prpos
  const [state, setState] = useSetState<any>({
    loading: false,
    errInfo: [],
    btnLoading: false,
  })

  useEffect(() => {
    console.log(drawerList)

    let data: any = []
    vendorList.map((item, index) => {
      data.push({
        vendorId: item.ucenterUserId,
        vendorName: item.vendorName,
      })
    })
    formRef.current?.onFormRef()?.setFieldsValue({
      drawingList: data,
    })
  }, [open])

  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  const onsubmit = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        let data = cloneDeep(values)
        data.orderId = orderId
        data.drawingList = data.drawingList.filter(item => {
          if (item.drawingList && item.drawingList.length > 0) {
            item.vendorName = undefined
            item.drawingList.forEach(eve => {
              eve.name = eve.label
              eve.url = eve.value
              eve.label = undefined
              eve.key = undefined
              eve.value = undefined
            })
            item.vendorProductList = vendorList?.filter(vendor => vendor.ucenterUserId === item.vendorId)?.[0]?.vendorProductList || []
            return true
          } else {
            return false
          }
        })
        setState({ btnLoading: true })

        //提交
        startCustomDrawing(data)
          .then(res => {
            message.success('提交成功')
            uploadFn()
            onCancel()
          })
          .finally(() => {
            setState({ btnLoading: false })
          })
      })
  }

  const onCancel = () => {
    onFormRef()?.resetFields()
    setOpen(false)
  }
  const getOptions = async () => {
    return Promise.resolve({
      drawerList,
    })
  }
  return (
    <SDrawerOrModal
      title={title}
      mode="modal"
      open={open}
      width={500}
      onCancel={onCancel}
      antdProps={{
        footer: (
          <div>
            <Button onClick={onCancel}>取消</Button>
            {/* disabled={state.errInfo.length} */}
            <Button
              style={{ marginLeft: 15 }}
              loading={state.btnLoading}
              type="primary"
              onClick={onsubmit}
            >
              提交
            </Button>
          </div>
        ),
      }}
    >
      {open && (
        <div>
          <Spin spinning={state.loading}>
            <div style={{}}>
              <p>当前报价有多个供应商，请将图纸与供应商进行匹配，再发起供应商审核</p>
            </div>
            <div>
              <SGeneralForms
                ref={formRef}
                httpOptionsFn={getOptions}
                layout={'vertical'}
                configs={[
                  {
                    type: 'multiple',
                    formName: 'drawingList',
                    isHideMultipleAddBtn: true,
                    isHideDelBtn: true,
                    formItem: [
                      {
                        spanCol: 24,
                        label: '供应商',
                        name: 'vendorName',
                        children: () => {
                          return <STooltipInput />
                        },
                      },
                      {
                        spanCol: 24,
                        label: '供应商',
                        name: 'vendorId',
                        hidden: true,
                        children: () => {
                          return <STooltipInput />
                        },
                      },
                      {
                        spanCol: 24,
                        label: '选择图纸',
                        name: 'drawingList',
                        type: 'select',
                        data: 'drawerList',
                        comConfig: {
                          mode: 'multiple',
                          fieldNames: { label: 'name', value: 'url' },
                          labelInValue: true,
                        },
                      },
                      {
                        label: '是否异形或玻台',
                        name: 'isUnCommon',
                        spanCol: 24,
                        type: 'switch',
                      },
                    ],
                  },
                ]}
              />
            </div>
          </Spin>
        </div>
      )}
    </SDrawerOrModal>
  )
}
